import React, { useMemo, useRef, useState } from "react";
import { Modal } from "antd";
import SwipeLeftIconSvg from "../../assets/ReactSvg/SwipeLeftIconSvg";
import SwipeRightIconSvg from "../../assets/ReactSvg/SwipeRightIconSvg";
import mixed from "../../assets/images/mix/generated-image.png";
import mixed1 from "../../assets/images/mix/generated-image (1).png";
import mixed2 from "../../assets/images/mix/generated-image (2).png";
import mixed3 from "../../assets/images/mix/generated-image (3).png";
import mixed4 from "../../assets/images/mix/generated-image (4).png";
import mixed5 from "../../assets/images/mix/generated-image (5).png";
import mixed6 from "../../assets/images/mix/generated-image (6).png";
import mixed7 from "../../assets/images/mix/generated-image (7).png";

import veg from "../../assets/images/veg/generated-image.png";
import veg1 from "../../assets/images/veg/generated-image (1).png";
import veg2 from "../../assets/images/veg/generated-image (2).png";
import veg3 from "../../assets/images/veg/generated-image (3).png";
import veg4 from "../../assets/images/veg/generated-image (4).png";
import veg5 from "../../assets/images/veg/generated-image (5).png";
import veg6 from "../../assets/images/veg/generated-image (6).png";
import veg7 from "../../assets/images/veg/generated-image (7).png";

import nonveg from "../../assets/images/nonveg/generated-image.png";
import nonveg1 from "../../assets/images/nonveg/generated-image (1).png";
import nonveg2 from "../../assets/images/nonveg/generated-image (2).png";
import nonveg3 from "../../assets/images/nonveg/generated-image (3).png";
import nonveg4 from "../../assets/images/nonveg/generated-image (4).png";
import nonveg5 from "../../assets/images/nonveg/generated-image (5).png";
import nonveg6 from "../../assets/images/nonveg/generated-image (6).png";
import nonveg7 from "../../assets/images/nonveg/generated-image (7).png";
import TinderCard from "react-tinder-card";
import SoupThumbnail from "../../assets/soup_thumbnail.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getDishRecommendation,
  updateFoodChoiceInfo,
} from "../../store/loginActions";
import classNames from "classnames";

const DISH_LIST_MIXED = [
  {
    dishName: "Butter Chicken with Garlic Naan",
    image: mixed,
  },
  {
    dishName: "Fiery Szechuan Hakka Noodles",
    image: mixed1,
  },
  {
    dishName: "Smoky Seekh Kebab Platter",
    image: mixed2,
  },
  {
    dishName: "Truffle Mushroom Risotto",
    image: mixed3,
  },
  {
    dishName: "Spicy Paneer Chilli Dry",
    image: mixed4,
  },
  {
    dishName: "Mediterranean Quinoa Bowl",
    image: mixed5,
  },
  {
    dishName: "Tandoori Chicken Tikka",
    image: mixed6,
  },
  {
    dishName: "Dal Makhani with Jeera Rice",
    image: mixed7,
  },
];

const DISH_LIST_VEG = [
  {
    dishName: "Paneer Butter Masala with Garlic Naan",
    image: veg,
  },
  {
    dishName: "Hakka Noodles with Manchurian Balls",
    image: veg1,
  },
  {
    dishName: "Tandoori Mushroom & Paneer Tikka",
    image: veg2,
  },
  {
    dishName: "Wild Mushroom & Truffle Risotto",
    image: veg3,
  },
  {
    dishName: "Chilli Paneer Dry",
    image: veg4,
  },
  {
    dishName: "Quinoa Buddha Bowl with Feta",
    image: veg5,
  },
  {
    dishName: "Malai Kofta in Rich Gravy",
    image: veg6,
  },
  {
    dishName: "Spinach & Ricotta Stuffed Ravioli",
    image: veg7,
  },
];

const DISH_LIST_NON_VEG = [
  {
    dishName: "Butter Chicken with Garlic Naan",
    image: nonveg,
  },
  {
    dishName: "Chicken Hakka Noodles (Spicy)",
    image: nonveg1,
  },
  {
    dishName: "Lamb Seekh Kebab Platter",
    image: nonveg2,
  },
  {
    dishName: "Grilled Salmon with Lemon Risotto",
    image: nonveg3,
  },
  {
    dishName: "Chilli Chicken Dry",
    image: nonveg4,
  },
  {
    dishName: "BBQ Chicken Caesar Salad",
    image: nonveg5,
  },
  {
    dishName: "Tandoori Chicken Tikka",
    image: nonveg6,
  },
  {
    dishName: "Mutton Rogan Josh with Basmati Rice",
    image: nonveg7,
  },
];

const QuestionSwiperCard = ({
  isModalOpen,
  handleCancel,
  foodChoiceState,
  userSelectionText,
  getDishRecommendationApi
}) => {
  const DISH_LIST =
    foodChoiceState === "VEG"
      ? DISH_LIST_VEG
      : foodChoiceState === "NONVEG"
      ? DISH_LIST_NON_VEG
      : DISH_LIST_MIXED;

  const [currentIndex, setCurrentIndex] = useState(DISH_LIST.length - 1);
  const [lastDirection, setLastDirection] = useState();
  const [isStartPageVisible, setIsStartPageVisible] = useState(true);
  const [questionList, setQuestionList] = useState([...DISH_LIST]);
  const currentIndexRef = useRef(currentIndex);
  const userid = useSelector(({ auth }) => auth.user.userid);
  const dispatch = useDispatch();

  const childRefs = useMemo(
    () =>
      Array(DISH_LIST.length)
        .fill(0)
        .map((i) => React.createRef()),
    []
  );

  const outOfFrame = (dishName, idx) => {
    console.log(
      `${dishName} (${idx}) left the screen!`,
      currentIndexRef.current
    );
    // handle the case in which go back is pressed before card goes outOfFrame
    currentIndexRef.current >= idx && childRefs[idx].current.restoreCard();
    // TODO: when quickly swipe and restore multiple times the same card,
    // it happens multiple outOfFrame events are queued and the card disappear
    // during latest swipes. Only the last outOfFrame event should be considered valid
  };

  const updateCurrentIndex = (val) => {
    setCurrentIndex(val);
    currentIndexRef.current = val;
  };

  const swiped = (direction, nameToDelete, index) => {
    setLastDirection(direction);
    updateCurrentIndex(index - 1);
    const currentIndex = questionList.findIndex(
      (q) => q.dishName === nameToDelete
    );
    const isInterested = direction === "right";
    const dummyQuestionList = [...questionList];
    dummyQuestionList[currentIndex].isInterested = isInterested;
    setQuestionList(dummyQuestionList);
    if (index === 0) {
      handleCancel();
      const interested = dummyQuestionList
        .filter((d) => d.isInterested)
        .map((d) => d.dishName)
        .join(", ");
      const notInterested = dummyQuestionList
        .filter((d) => !d.isInterested)
        .map((d) => d.dishName)
        .join(", ");
      const dummyQuestionListText = `Interesting dishes: ${interested}\nNot interested dishes: ${notInterested}`;

      const userSelectionString = `${userSelectionText}

        User submitted a quiz questionnaire where they answered the dishes they were interested in and not interested in, here are their answers:

        ${dummyQuestionListText}

        Response should contain an array of dishes from the pinecone database with their matching percentage
      Response format should be as follows, don’t add any more text:
      [{
      rank: 1,
      dish: "dish name",
      matchPercent: "matching percentage"
      },
      {
      rank: 2,
      dish: "dish name",
      matchPercent: "matching percentage"
      }]`;

      const payload = {
        question: userSelectionString,
      };
      getDishRecommendationApi(payload);
      if (userid) {
        const payload = { foodChoice: dummyQuestionList };
        dispatch(updateFoodChoiceInfo(userid, payload));
      }
    }
  };

  const canSwipe = currentIndex >= 0;

  const swipe = async (dir) => {
    if (canSwipe && currentIndex < DISH_LIST.length) {
      await childRefs[currentIndex].current.swipe(dir); // Swipe the card!
    }
  };

  const getResponsiveFontSize = () => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    const minWidth = 354;
    const maxWidth = 425;
    const minFont = 25;
    const maxFont = 32;

    // Width-based logic (unchanged)
    let widthBasedFont;
    if (screenWidth <= minWidth) widthBasedFont = minFont;
    else if (screenWidth >= maxWidth) widthBasedFont = maxFont;
    else {
      const widthRatio = (screenWidth - minWidth) / (maxWidth - minWidth);
      widthBasedFont = minFont + widthRatio * (maxFont - minFont);
    }

    // Height override logic
    const minHeight = 659;
    const maxHeight = 809;
    const minHeightFont = 20;

    if (screenHeight <= minHeight) {
      return minHeightFont;
    } else if (screenHeight >= maxHeight) {
      return widthBasedFont;
    } else {
      // Interpolate between 20 (at 659) and widthBasedFont (at 809)
      const heightRatio = (screenHeight - minHeight) / (maxHeight - minHeight);
      return minHeightFont + heightRatio * (widthBasedFont - minHeightFont);
    }
  };

  const fontSize = getResponsiveFontSize();

  const getResponsiveGap = () => {
    const screenHeight = window.innerHeight;

    const minHeight = 659;
    const maxHeight = 809;
    const minGap = 20;
    const maxGap = 40;

    if (screenHeight <= minHeight) return minGap;
    if (screenHeight >= maxHeight) return maxGap;

    const ratio = (screenHeight - minHeight) / (maxHeight - minHeight);
    return minGap + ratio * (maxGap - minGap);
  };

  const gap = getResponsiveGap();

  const getResponsiveSize = () => {
    const screenHeight = window.innerHeight;

    const minHeight = 659;
    const maxHeight = 809;
    const minGap = 65;
    const maxGap = 72;

    if (screenHeight <= minHeight) return minGap;
    if (screenHeight >= maxHeight) return maxGap;

    const ratio = (screenHeight - minHeight) / (maxHeight - minHeight);
    return minGap + ratio * (maxGap - minGap);
  };

  const size = getResponsiveSize();

  const getResponsiveBottom = () => {
    const screenHeight = window.innerHeight;

    const minHeight = 659;
    const maxHeight = 809;
    const minBottom = 15;
    const maxBottom = 30;

    if (screenHeight <= minHeight) return minBottom;
    if (screenHeight >= maxHeight) return maxBottom;

    const ratio = (screenHeight - minHeight) / (maxHeight - minHeight);
    return minBottom + ratio * (maxBottom - minBottom);
  };

  const bottom = getResponsiveBottom();

  const getResponsiveCardSize = () => {
    const screenHeight = window.innerHeight;

    const minHeight = 659;
    const maxHeight = 809;

    const minCardWidth = 240;
    const maxCardWidth = 280;

    const minCardHeight = 400;
    const maxCardHeight = 460;

    if (screenHeight <= minHeight) {
      return { cardWidth: minCardWidth, cardHeight: minCardHeight };
    }

    if (screenHeight >= maxHeight) {
      return { cardWidth: maxCardWidth, cardHeight: maxCardHeight };
    }

    const ratio = (screenHeight - minHeight) / (maxHeight - minHeight);

    const cardWidth = minCardWidth + ratio * (maxCardWidth - minCardWidth);
    const cardHeight = minCardHeight + ratio * (maxCardHeight - minCardHeight);

    return { cardWidth, cardHeight };
  };

  const { cardWidth, cardHeight } = getResponsiveCardSize();

  return (
    <div className="recommendationModal" title="Find your favourite soup">
      <div
        className={classNames("swipableCardsWrapper")}
        style={{ paddingTop: gap }}
      >
        <div className="swipableCardsContainer">
          <div className="tinderCardsContainer">
            {isStartPageVisible ? (
              <div
                style={{ rowGap: gap }}
                className="tinderMainThumbImageWrapper"
              >
                <img src={SoupThumbnail} className="tinderMainThumbImage" />
                <div
                  style={{ fontSize: fontSize }}
                  className="tinderMainThumbImageHeader Satoshi"
                >
                  Swipe right if you like the dish, swipe left if you don’t.
                </div>
              </div>
            ) : (
              <>
                {DISH_LIST.map((character, index) => (
                  <TinderCard
                    ref={childRefs[index]}
                    className="tinderCardsSwipe"
                    key={character.dishName}
                    onSwipe={(dir) => swiped(dir, character.dishName, index)}
                    onCardLeftScreen={() =>
                      outOfFrame(character.dishName, index)
                    }
                  >
                    <div
                      style={{ width: cardWidth, height: cardHeight }}
                      className="tinderCard"
                    >
                      <div>
                        <img
                          style={{ height: "100%", objectFit: "cover" }}
                          src={character.image}
                          alt={character.dishName}
                        />
                        <div className="tinderCardHeader Satoshi">
                          {character.dishName}
                        </div>
                        <div className="tinderCardContentBottomShadow"></div>
                      </div>
                    </div>
                  </TinderCard>
                ))}
                <div
                  style={{
                    transform: "translate3d(0px, 0px, 0px) rotate(4deg)",
                    width: cardWidth,
                    height: cardHeight,
                  }}
                  className="tinderCardsSwipeDummy"
                ></div>
                <div
                  style={{
                    transform: "translate3d(0px, 0px, 0px) rotate(-4deg)",
                    width: cardWidth,
                    height: cardHeight,
                  }}
                  className="tinderCardsSwipeDummy"
                ></div>
              </>
            )}
          </div>
        </div>
      </div>
      {isStartPageVisible ? (
        <div style={{ bottom: bottom }} className="tinderSwipeButtonsMainThumb">
          <button
            className="recommendedAnimatedBtnMainThumb Satoshi"
            onClick={() => setIsStartPageVisible(false)}
            style={{ height: size, width: size }}
          >
            Let's Go!
          </button>
        </div>
      ) : (
        <div className="tinderSwipeButtons">
          <div className="recommendedAnimatedBtnWrapper">
            <button
              className="recommendedAnimatedBtn"
              onClick={() => swipe("left")}
            >
              <SwipeLeftIconSvg />
            </button>
            <div className="recommendedAnimatedTxt Satoshi">No</div>
          </div>
          <div className="recommendedAnimatedBtnWrapper">
            <button
              className="recommendedAnimatedBtn"
              onClick={() => swipe("right")}
            >
              <SwipeRightIconSvg />
            </button>
            <div className="recommendedAnimatedTxt Satoshi">Yes</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuestionSwiperCard;
